import { render, staticRenderFns } from "./PointsDetail.vue?vue&type=template&id=35a70cc2&scoped=true"
import script from "./PointsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointsDetail.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a70cc2",
  null
  
)

export default component.exports